import { render, staticRenderFns } from "./CourseGroupEditor.vue?vue&type=template&id=833cc190"
import script from "./CourseGroupEditor.vue?vue&type=script&lang=js"
export * from "./CourseGroupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports